import KneeReplacementRisks from "../../../images/Knee/KneeReplacementRisks.jpg";
export default function ShoulderReplacementRisks() {
  return (
    <div
      className="row KneeReplacementDifferentTypes KneeReplacementPreparation expertiseRisks shared-margin"
      style={{ marginBottom: 0 }}
    >
      <div className="col l10 offset-l1">
        <div className="col s12 right-side">
          <h6>
            <u>What are the risks of shoulder replacement? </u>
          </h6>
          <p>
            About 10 000 shoulder replacements are performed in Canada every
            year and results are typically excellent in 90% of cases. About 90%
            of shoulder replacements can also be expected to last 10 years or
            more. However, there are risks of some complications and these
            include: infection, stiffness, loosening, dislocation, fracture,
            injury to an artery or nerve and medical complications. These are
            rare and the risks can change depending on your health. These will
            be discussed in detail during your appointment with Dr Mutch.
          </p>
          <br />
          <br />
        </div>
        {/* <div className="col l6 s12 left-side">
          <img
            className="z-depth-1 KneeReplacementDifferentTypesImage"
            src={KneeReplacementRisks}
            alt=""
          />
        </div> */}
      </div>
    </div>
  );
}
